import * as React from 'react';
import styled from 'styled-components/macro';

import color from '../../utils/color';

const SpinnerContainer = styled.div<{
  width?: number;
  height?: number;
  afterWidth?: number;
  afterHeight?: number;
  left?: number;
}>`
  color: ${color.NEGATIVE};
  display: inline-block;
  position: relative;
  width: ${({ width }) => (width ? width : 64)}px;
  height: ${({ width }) => (width ? width : 64)}px;
  div {
    transform-origin: ${({ width }) => (width ? width / 2 : 32)}px
      ${({ height }) => (height ? height / 2 : 32)}px;
    animation: lds-spinner 1.2s linear infinite;
  }
  div:after {
    content: ' ';
    display: block;
    position: absolute;
    top: 3px;
    left: ${({ left }) => (left ? left : 29)}px;
    width: ${({ afterWidth }) => (afterWidth ? afterWidth : 5)}px;
    height: ${({ afterHeight }) => (afterHeight ? afterHeight : 14)}px;
    border-radius: 20%;
    background: ${color.NEUTRAL};
  }
  div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }
  div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }
  div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }
  div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }
  div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }
  div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }
  div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }
  div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }
  div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }
  div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }
  div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
  @keyframes lds-spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

const TextContainer = styled.div<{
  width?: number;
  height?: number;
  afterWidth?: number;
  afterHeight?: number;
  left?: number;
}>`
  color: ${color.NEUTRAL_DARK};
  display: block;
  position: relative;
  text-align: center;
`;

interface Props {
  width?: number;
  height?: number;
  afterWidth?: number;
  afterHeight?: number;
  left?: number;
  text?: string;
}

export const Spinner: React.FC<Props> = ({
  width,
  height,
  afterHeight,
  afterWidth,
  left,
  text
}) => {
  return (
    <div>
      <SpinnerContainer
        width={width}
        height={height}
        afterWidth={afterWidth}
        afterHeight={afterHeight}
        left={left}
      >
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </SpinnerContainer>
      {text && <TextContainer>{text}</TextContainer>}
    </div>
  );
};
